module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"continue":"Continue","are_you_sure_delete":"Are you sure you want to delete this form? This form will be deleted permanently."},"id":{"continue":"Lanjutkan","are_you_sure_delete":"Anda yakin ingin menghapus format ini? Format ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
